// extracted by mini-css-extract-plugin
export default {"layout":"layout__bzZ5FD","descriptions":"descriptions__r0mKWR"};